import * as types from "./types";
import * as pageTypes from "../page/types";

const transformedSession = (session: any) => {
  if (
    !Object.keys(session).length || !session.order_type ||
    (session.order_type == "delivery" && !session.area_id) ||
    (session.order_type == "pickup" && !session.outlet_id)
  ) {
    session.showAreaSelect = true;
    session.mandatory = true;
  } else {
    session.showAreaSelect = false;
    session.mandatory = false;
  }
  return session;
}

const sessionReducer = ( state = {}, action: any ) => {
  switch( action.type ) {
    case pageTypes.FETCH_HOME_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_CHECKOUT_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_TRACKING_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_PROFILE_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_PAST_ORDERS_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_LOYALTY_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_PAYMENT_PROCESSING_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_TERMS_OF_SERVICE_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_RIDER_TRACKING_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_SIGN_IN_CONFIGURATIONS_SUCCESS:
    case pageTypes.FETCH_ORDER_DETAILS_CONFIGURATIONS_SUCCESS:
      return transformedSession(action.payload.data.session);
    case types.SET_SESSION:
      return {
        ...state,
        ...action.payload,
      };
    case types.CHANGE_DELIVERY_AREA_SUCCESS:
      return action.payload.data;
    case types.CLEAR_SESSION:
      return { ...state };

    default: return state;
  }
};

const reducer = sessionReducer;

export default reducer;
